import Box from '@mui/material/Box'
import {
  RiCheckboxCircleLine,
  RiLineChartLine,
  RiMoneyDollarCircleFill,
} from '@/shared/icons/remix'
import { useSpRewardsSummary } from '@/features/rewards/api'
import {
  homeStatOrangeBg,
  homeStatOrangeIcon,
  homeStatPurpleBg,
  homeStatPurpleIcon,
  homeStatRedBg,
  homeStatRedIcon,
  homeContentInnerSx,
  homeContentShellSx,
  homeStatsRowSx,
} from '../styles/homeStyles'
import { HomeStatCard } from './HomeStatCard'

export function HomeStatsRow() {
  const { data: summary } = useSpRewardsSummary()

  const availableBalance = summary?.availableBalanceUsd ?? 0
  const totalEarned = summary?.lifetimeEarnedUsd ?? 0
  const surveysCompleted = summary?.surveysCompleted ?? 0

  return (
    <Box sx={homeContentShellSx}>
      <Box sx={homeContentInnerSx}>
        <Box sx={homeStatsRowSx} data-testid="home-stats-row">
        <HomeStatCard
          label="Available Balance"
          value={availableBalance}
          valueFormat="currency"
          cardBg={homeStatOrangeBg}
          iconBg={homeStatOrangeIcon}
          icon={<RiMoneyDollarCircleFill size={24} />}
          testId="home-stat-balance"
        />
        <HomeStatCard
          label="Total Earned"
          value={totalEarned}
          valueFormat="currency"
          cardBg={homeStatPurpleBg}
          iconBg={homeStatPurpleIcon}
          icon={<RiLineChartLine size={24} />}
          testId="home-stat-earned"
        />
        <HomeStatCard
          label="Survey Completed"
          value={surveysCompleted}
          cardBg={homeStatRedBg}
          iconBg={homeStatRedIcon}
          icon={<RiCheckboxCircleLine size={24} />}
          testId="home-stat-completed"
        />
        </Box>
      </Box>
    </Box>
  )
}
